import React from 'react';
type Skill = {
  number: number;
  emoji: string;
  title: string;
  tagline: string;
  intro: string;
  bullets: string[];
  image: string;
  featured?: boolean;
};
const skills: Skill[] = [{
  number: 1,
  emoji: '📗',
  title: 'COMPRENSIÓN LECTORA',
  tagline: 'Para comprender, interpretar y analizar mejor la información.',
  intro: 'Actividades para trabajar:',
  bullets: ['Ideas principales y secundarias', 'Información explícita e implícita', 'Inferencias y relaciones causa-consecuencia', 'Noticias, textos científicos e históricos', 'Interpretación de imágenes, gráficos y tablas'],
  image: 'https://cdn.magicpatterns.com/uploads/rgUEqBkgyRbgECydMdkV2X/habilidad_(1).png'
}, {
  number: 2,
  emoji: '✍️',
  title: 'PRODUCCIÓN ESCRITA',
  tagline: 'Para expresar ideas con mayor claridad y organización.',
  intro: 'Actividades para trabajar:',
  bullets: ['Organización de ideas', 'Construcción de párrafos', 'Coherencia y cohesión', 'Argumentación y fundamentación', 'Revisión y mejora de textos'],
  image: 'https://cdn.magicpatterns.com/uploads/mWqDz4qXySQpCBVq4AdZGL/habilidad_(2).png'
}, {
  number: 3,
  emoji: '📚',
  title: 'TÉCNICAS DE ESTUDIO',
  tagline: 'Herramientas concretas para estudiar de manera más eficiente.',
  intro: 'Actividades sobre:',
  bullets: ['Subrayado inteligente', 'Resúmenes', 'Cuadros y mapas conceptuales', 'Fichas de estudio', 'Preparación de evaluaciones'],
  image: 'https://cdn.magicpatterns.com/uploads/uDebdAENx2f2Ai9k47JL4r/habilidad_(3).png'
}, {
  number: 4,
  emoji: '⏱️',
  title: 'APRENDER A ESTUDIAR',
  tagline: 'Para desarrollar hábitos, autonomía y organización.',
  intro: 'Actividades para trabajar:',
  bullets: ['Rutinas de estudio', 'Organización del tiempo', 'Priorización de tareas', 'Concentración y procrastinación', 'Preparación para evaluaciones'],
  image: 'https://cdn.magicpatterns.com/uploads/s12J4Biq7shAG8X6ssXqCq/habilidad_(4).png'
}, {
  number: 5,
  emoji: '🔎',
  title: 'PENSAMIENTO CRÍTICO',
  tagline: 'Para aprender a analizar antes de aceptar una información como verdadera.',
  intro: 'Actividades sobre:',
  bullets: ['Hechos, opiniones e interpretaciones', 'Confiabilidad de las fuentes', 'Sesgos, estereotipos y manipulación', 'Publicidad, redes sociales y fake news', 'Argumentos y toma de decisiones'],
  image: 'https://cdn.magicpatterns.com/uploads/iT4ebCqg6QgE3iakJDsKoL/habilidad_(5).png',
  featured: true
}, {
  number: 6,
  emoji: '🧭',
  title: 'ORIENTACIÓN VOCACIONAL',
  tagline: 'Para acompañar a los estudiantes a pensar quiénes son y hacia dónde quieren ir.',
  intro: 'Actividades para explorar:',
  bullets: ['Intereses personales', 'Fortalezas y talentos', 'Valores que me guían', 'Profesiones y posibilidades', 'Metas y proyecto de vida'],
  image: 'https://cdn.magicpatterns.com/uploads/8675WWPQsgLV4ad5H8u7BE/habilidad_(6).png'
}, {
  number: 7,
  emoji: '💬',
  title: 'DEBATE Y ARGUMENTACIÓN',
  tagline: 'Para expresar ideas, escuchar otras miradas y fundamentar opiniones.',
  intro: 'Actividades para desarrollar:',
  bullets: ['Escucha activa y respeto', 'Construcción de argumentos', 'Reconocimiento de distintas posturas', 'Exposición oral y pensamiento flexible', 'Debate y construcción de acuerdos'],
  image: 'https://cdn.magicpatterns.com/uploads/5fxbNKRf9pNDBJRbpmUXQX/habilidad_(7).png'
}, {
  number: 8,
  emoji: '🤖',
  title: 'INTELIGENCIA ARTIFICIAL APLICADA AL ESTUDIO',
  tagline: 'Para aprender a utilizar la IA como herramienta y no simplemente para copiar respuestas.',
  intro: 'Actividades para trabajar:',
  bullets: ['Cómo hacer mejores prompts', 'Comprender y resumir contenidos', 'Organizar el estudio con IA', 'Mejorar producciones escritas', 'Verificar información y usar la IA responsablemente'],
  image: 'https://cdn.magicpatterns.com/uploads/eZup5q5jjPVgSu1L1tFoxV/habilidad_(8).png',
  featured: true
}];
function SkillRow({
  skill,
  reverse
}: {
  skill: Skill;
  reverse: boolean;
}) {
  return <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 rounded-3xl p-6 ${skill.featured ? 'bg-[#F0FAFB] border-2 border-[#17A2AE] shadow-lg' : 'bg-gray-50 border border-gray-200'}`} data-id="element-139" data-mp="pofhallpdj43">
      <div className="w-full md:w-1/2 flex justify-center" data-id="element-140" data-mp="35bdud1o5txrm">
        <img src={skill.image} alt={`Habilidad ${skill.number}: ${skill.title}`} className="w-[320px] max-w-full h-auto object-contain drop-shadow-xl rounded-lg" data-id="element-141" data-mp="359ue3b2i7mpu" />
      </div>

      <div className="w-full md:w-1/2" data-id="element-142" data-mp="3eb0w5oksx5l7">
        {skill.featured && <span className="inline-block bg-[#1B3A6B] text-white text-[10px] font-black tracking-wide px-3 py-1 rounded-full mb-3 uppercase" data-id="element-143" data-mp="3jan9rz4jknuj">
            ⭐ El gran diferencial
          </span>}
        <h3 className="text-xl md:text-2xl font-black mb-2 text-[#1B3A6B] leading-tight" data-id="element-144" data-mp="3t0qaymlth83y">
          {skill.emoji} HABILIDAD {skill.number} — {skill.title}
        </h3>
        <p className="text-lg text-gray-700 mb-4" data-id="element-145" data-mp="yqr4efczdqj">{skill.tagline}</p>
        <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-146" data-mp="5x20yp5nlo8r">
          {skill.intro}
        </p>
        <ul className="space-y-1.5 text-base text-gray-800" data-id="element-147" data-mp="1qfmbo9rudti9">
          {skill.bullets.map(item => <li key={item} className="flex items-start" data-id="element-148" data-mp="1le6syod4zz31">
              <span className="text-[#17A2AE] mr-2 font-bold" data-id="element-149" data-mp="1hd39zszslmxl">✔</span>
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}
export function SkillsSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-150" data-mp="1cgmo75g2fkno">
      <div className="max-w-5xl mx-auto" data-id="element-151" data-mp="293hkdf8lkh4i">
        <div className="text-center mb-8" data-id="element-152" data-mp="296nbt14p7v3e">
          <h2 className="text-[20px] md:text-2xl font-black mb-3 text-[#1B3A6B]" data-id="element-153" data-mp="252paqkvtca7p">
            ¿QUÉ HABILIDADES VAS A ENCONTRAR?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-154" data-mp="20ae6j5u1i29c">
            Ocho bloques independientes. Elegís la habilidad que necesitás
            trabajar y la llevás al aula.
          </p>
        </div>

        <div className="space-y-8" data-id="element-155" data-mp="2sumk85bsiq5n">
          {skills.map((skill, index) => <SkillRow key={skill.number} skill={skill} reverse={index % 2 === 1} data-id="element-156" data-mp="2o11ji5itbi2r" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}